/**
 * Marca o país destacado del mes: cómo le fue contra el AOP y contra el año
 * anterior.
 *
 * Sale de una query DAX al modelo semántico de ventas (no de una tabla del
 * backend), así que es sólo de lectura: se arma con `fromRow` a partir de la
 * fila que devuelve `executeQueries`.
 */
export class SalesHighlight {

    /** Nombre de la marca o del país, tal cual viene del modelo */
    name: string;

    /** Volumen real del mes */
    actualVolume: number;

    /** Volumen presupuestado (AOP) del mes */
    aopVolume: number;

    /** Volumen del mismo mes del año anterior (YAG) */
    lastYearVolume: number;

    /** Margen real del mes */
    actualMargin: number;

    /** Margen presupuestado (AOP) del mes */
    aopMargin: number;

    /** Diferencia de volumen contra el AOP: es lo que ordena el ranking */
    volumeImpact: number;

    /** Diferencia de margen contra el AOP */
    marginImpact: number;

    /** Venta y margen, los dos por encima del AOP */
    bothPositive: boolean;
}
